import React from 'react';
import { Link } from 'react-router-dom';
import { Menu } from 'antd';
import {
  DashboardOutlined,
  SettingOutlined,
  KeyOutlined,
  SecurityScanOutlined,
  CodeSandboxOutlined,
  GoldOutlined,
  TeamOutlined,
  ApiOutlined,
  PhoneOutlined,
  WifiOutlined,
  ReadOutlined,
  GlobalOutlined,
  LinkOutlined,
  DatabaseOutlined,
  LoginOutlined,
  ToolOutlined,
  BankOutlined,
  HddOutlined,
  TableOutlined,
  LogoutOutlined,
  BarChartOutlined,
  ClockCircleOutlined,
  FolderOutlined,
  FieldTimeOutlined,
  PauseCircleOutlined,
  MailOutlined,
  CloudSyncOutlined,
  CloudDownloadOutlined,
  UsergroupAddOutlined,
  FileTextOutlined,
  ShoppingOutlined,
  TagsOutlined,
  PercentageOutlined,
  SyncOutlined,
  DollarOutlined,
  CheckSquareOutlined,
  AppstoreOutlined,
  ScheduleOutlined,
} from '@ant-design/icons';
import { accessControls } from 'utils';
import Auth from 'auth';

const DefaultSuperAdminMenu = ({
  permissions,
  networkSettings,
  defaultSelected,
  defaultOpened,
  menuClickHandle,
}) => {
  return (
    <Menu
      onClick={menuClickHandle}
      theme={networkSettings.navbar_current_mode === 'dark' ? 'dark' : 'light'}
      selectedKeys={[defaultSelected]}
      defaultOpenKeys={defaultOpened}
      mode="inline"
      style={{
        backgroundColor:
          networkSettings.navbar_current_mode === 'dark'
            ? networkSettings.navbar_color_dark_mode
            : networkSettings.navbar_color_light_mode,
      }}
    >
      <Menu.Item
        key="/dashboard"
        icon={<DashboardOutlined style={{ fontSize: '16px' }} />}
      >
        <Link to="/">Dashboard</Link>
      </Menu.Item>

      {/* Super Admin */}
      {(accessControls.can(permissions, 'Client.create:any') ||
        accessControls.can(permissions, 'Client.update:any') ||
        accessControls.can(permissions, 'Client.delete:any') ||
        accessControls.can(permissions, 'AccessControl.read:any') ||
        accessControls.can(permissions, 'Company.create:any') ||
        accessControls.can(permissions, 'Company.update:any') ||
        accessControls.can(permissions, 'Branch.read:any') ||
        accessControls.can(permissions, 'User.read:any') ||
        accessControls.can(permissions, 'CallReport.read:any') ||
        accessControls.can(permissions, 'IspProvider.read:any')) && (
        <Menu.SubMenu
          key="/super-admin"
          icon={<SettingOutlined style={{ fontSize: '16px' }} />}
          title="Super Admin"
        >
          {accessControls.can(permissions, 'ApiKey.read:any') && (
            <Menu.Item
              key="/apikeys"
              icon={<KeyOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/apikeys">API Keys</Link>
            </Menu.Item>
          )}
          {accessControls.can(permissions, 'AccessControl.read:any') && (
            <Menu.Item
              key="/access-control"
              icon={<SecurityScanOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/access-control">Access Control</Link>
            </Menu.Item>
          )}
          {/* Show companies section only if have create or update permission */}
          {(accessControls.can(permissions, 'Company.create:any') ||
            accessControls.can(permissions, 'Company.update:any')) && (
            <Menu.Item
              key="/companies"
              icon={<CodeSandboxOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/companies">Companies</Link>
            </Menu.Item>
          )}
          {(accessControls.can(permissions, 'Client.create:any') ||
            accessControls.can(permissions, 'Client.update:any') ||
            accessControls.can(permissions, 'Client.delete:any')) && (
            <Menu.Item
              key="/clients"
              icon={<HddOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/clients">Resellers</Link>
            </Menu.Item>
          )}
          {accessControls.can(permissions, 'Company.read:any') && (
            <Menu.Item
              key="/yardi-sync"
              icon={<CloudSyncOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/yardi-sync">Yardi Sync</Link>
            </Menu.Item>
          )}
          {accessControls.can(permissions, 'Branch.read:any') && (
            <Menu.Item
              key="/branches"
              icon={<GoldOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/branches">Branches</Link>
            </Menu.Item>
          )}
          {(accessControls.can(permissions, 'Client.create:any') ||
            accessControls.can(permissions, 'Client.update:any') ||
            accessControls.can(permissions, 'Client.delete:any')) && (
            <Menu.Item
              key="/branchnetwork/stats"
              icon={<BarChartOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/branchnetwork/stats">Branch Network Stats</Link>
            </Menu.Item>
          )}
          {Auth.getRole() === 10 && (
            <Menu.Item
              key="/super-admin/data-export"
              icon={<CloudDownloadOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/super-admin/data-export">Data Export</Link>
            </Menu.Item>
          )}
          {accessControls.can(permissions, 'User.read:any') && (
            <Menu.Item
              key="/users"
              icon={<TeamOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/users">Users</Link>
            </Menu.Item>
          )}
          {accessControls.can(permissions, 'User.read:any') &&
            Auth.getRole() === 10 && (
              <Menu.Item
                key="/users/super-admins"
                icon={<UsergroupAddOutlined style={{ fontSize: '16px' }} />}
              >
                <Link to="/users/super-admins">Super Admin Users</Link>
              </Menu.Item>
            )}
          {accessControls.can(permissions, 'User.read:any') &&
            Auth.getRole() === 10 && (
              <Menu.Item
                key="/users/legal-acceptance"
                icon={<FileTextOutlined style={{ fontSize: '16px' }} />}
              >
                <Link to="/users/legal-acceptance">Terms Acceptance</Link>
              </Menu.Item>
            )}
          {accessControls.can(permissions, 'User.read:any') && (
            <Menu.Item
              key="/third-party-credentials"
              icon={<ApiOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/third-party-credentials">Third-Party Credentials</Link>
            </Menu.Item>
          )}
          {accessControls.can(permissions, 'CallReport.read:any') && (
            <Menu.Item
              key="/call-report"
              icon={<PhoneOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/call-report">Call Report</Link>
            </Menu.Item>
          )}
          {accessControls.can(permissions, 'IspProvider.read:any') && (
            <Menu.Item
              key="/manage-isp-provider"
              icon={<WifiOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/manage-isp-provider">ISP Vendors</Link>
            </Menu.Item>
          )}
        </Menu.SubMenu>
      )}

      {/* Config Admin */}
      {(accessControls.can(
        permissions,
        'NetworkingToolIpPortRegistry.read:any',
      ) ||
        accessControls.can(
          permissions,
          'NetworkingToolClientFirewall.read:any',
        ) ||
        accessControls.can(permissions, 'Report.read:any') ||
        accessControls.can(permissions, 'EquipmentType.read:any') ||
        accessControls.can(permissions, 'Vendor.read:any') ||
        accessControls.can(permissions, 'Model.read:any') ||
        accessControls.can(permissions, 'EquipmentOwnership.read:any') ||
        accessControls.can(
          permissions,
          'NetworkingToolVlanRegistry.read:any',
        ) ||
        accessControls.can(permissions, 'NetworkingToolIpRegistry.read:any') ||
        accessControls.can(permissions, 'NetworkingToolCountries.read:any') ||
        accessControls.can(permissions, 'NetworkingToolStates.read:any') ||
        accessControls.can(permissions, 'NetworkingToolBandwidth.read:any') ||
        accessControls.can(
          permissions,
          'NetworkingToolQosOptions.read:any',
        )) && (
        <Menu.SubMenu
          key="/config-admin"
          icon={<SettingOutlined style={{ fontSize: '16px' }} />}
          title="Config Admin"
        >
          {accessControls.can(
            permissions,
            'NetworkingToolIpPortRegistry.read:any',
          ) && (
            <Menu.Item
              key="/ipportregistry"
              icon={<GlobalOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/ipportregistry">IP Port Registry</Link>
            </Menu.Item>
          )}
          {accessControls.can(
            permissions,
            'NetworkingToolClientFirewall.read:any',
          ) && (
            <Menu.Item
              key="/clientfirewall"
              icon={<SecurityScanOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/clientfirewall">Client Firewall</Link>
            </Menu.Item>
          )}
          {/* Temporarily hidden - feature not yet implemented */}
          {/* {accessControls.can(
            permissions,
            'NetworkingToolFirewallPorts.read:any',
          ) && (
            <Menu.Item
              key="/firewallports"
              icon={<SecurityScanOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/firewallports">Firewall Ports</Link>
            </Menu.Item>
          )} */}
          {accessControls.can(permissions, 'Report.read:any') && (
            <Menu.Item
              key="/reports"
              icon={<TableOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/reports">Reports</Link>
            </Menu.Item>
          )}
          {accessControls.can(permissions, 'EquipmentType.read:any') && (
            <Menu.Item
              key="/equipmenttype"
              icon={<HddOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/equipmenttype">Equipment Type</Link>
            </Menu.Item>
          )}
          {accessControls.can(permissions, 'Vendor.read:any') && (
            <Menu.Item
              key="/equipment-vendor"
              icon={<CodeSandboxOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/equipment-vendor">Equipment Vendor</Link>
            </Menu.Item>
          )}
          {accessControls.can(permissions, 'Model.read:any') && (
            <Menu.Item
              key="/equipment-model"
              icon={<HddOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/equipment-model">Equipment Model</Link>
            </Menu.Item>
          )}
          {accessControls.can(
            permissions,
            'NetworkingToolVlanRegistry.read:any',
          ) && (
            <Menu.Item
              key="/vlanregistry"
              icon={<GlobalOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/vlanregistry">VLAN Registry</Link>
            </Menu.Item>
          )}
          {accessControls.can(
            permissions,
            'NetworkingToolIpRegistry.read:any',
          ) && (
            <Menu.Item
              key="/ipregistry"
              icon={<GlobalOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/ipregistry">IP Registry</Link>
            </Menu.Item>
          )}
          {accessControls.can(
            permissions,
            'NetworkingToolCountries.read:any',
          ) && (
            <Menu.Item
              key="/countries"
              icon={<GlobalOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/countries">Countries</Link>
            </Menu.Item>
          )}
          {accessControls.can(permissions, 'NetworkingToolStates.read:any') && (
            <Menu.Item
              key="/states"
              icon={<GlobalOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/states">States</Link>
            </Menu.Item>
          )}
          {accessControls.can(
            permissions,
            'NetworkingToolBandwidth.read:any',
          ) && (
            <Menu.Item
              key="/bandwidth"
              icon={<WifiOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/bandwidth">Bandwidth</Link>
            </Menu.Item>
          )}
          {accessControls.can(
            permissions,
            'NetworkingToolQosOptions.read:any',
          ) && (
            <Menu.Item
              key="/qosoptions"
              icon={<SettingOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/qosoptions">QoS Options</Link>
            </Menu.Item>
          )}
          {accessControls.can(
            permissions,
            'NetworkingToolEquipmentOwnership.read:any',
          ) && (
            <Menu.Item
              key="/equipmentownership"
              icon={<GoldOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/equipmentownership">Equipment Ownership</Link>
            </Menu.Item>
          )}
        </Menu.SubMenu>
      )}

      {/* Time Tracker - super admin only for now */}
      {accessControls.can(permissions, 'TimeTracker.read:any') && (
        <Menu.SubMenu
          key="/time-tracker"
          icon={<ClockCircleOutlined style={{ fontSize: '16px' }} />}
          title="Time Tracker"
        >
          {accessControls.can(permissions, 'TimeTrackerUserGroup.read:any') && (
            <Menu.Item
              key="/time-tracker/user-groups"
              icon={<UsergroupAddOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/time-tracker/user-groups">User groups</Link>
            </Menu.Item>
          )}
          {(accessControls.can(permissions, 'TimeTrackerProject.update:any') || accessControls.can(permissions, 'TimeTrackerProject.delete:any')) && (
            <Menu.Item
              key="/time-tracker/projects"
              icon={<FolderOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/time-tracker/projects">Projects</Link>
            </Menu.Item>
          )}
          <Menu.Item
            key="/time-tracker/tracker"
            icon={<FieldTimeOutlined style={{ fontSize: '16px' }} />}
          >
            <Link to="/time-tracker/tracker">Tracker</Link>
          </Menu.Item>
          <Menu.Item
            key="/time-tracker/reports"
            icon={<BarChartOutlined style={{ fontSize: '16px' }} />}
          >
            <Link to="/time-tracker/reports">Reports</Link>
          </Menu.Item>
          {Number(Auth.getRole()) === 10 && (
            <Menu.Item
              key="/time-tracker/open-timers"
              icon={<PauseCircleOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/time-tracker/open-timers">Open timers</Link>
            </Menu.Item>
          )}
          {accessControls.can(permissions, 'Scheduling.read:any') && (
            <Menu.Item
              key="/time-tracker/scheduling"
              icon={<ScheduleOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/time-tracker/scheduling">Schedules</Link>
            </Menu.Item>
          )}
          {accessControls.can(permissions, 'Scheduling.update:any') && (
            <Menu.Item
              key="/time-tracker/scheduling/activities"
              icon={<ScheduleOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/time-tracker/scheduling/activities">
                Schedule activities
              </Link>
            </Menu.Item>
          )}
        </Menu.SubMenu>
      )}

      {/* KB */}
      {(accessControls.can(permissions, 'KBCategory.read:any') ||
        accessControls.can(permissions, 'KBPost.read:any')) && (
        <Menu.SubMenu
          key="/kb"
          icon={<ReadOutlined style={{ fontSize: '16px' }} />}
          title="KB"
        >
          {accessControls.can(permissions, 'KBCategory.read:any') && (
            <Menu.Item key="/knowledge-base/categories">
              <Link to="/knowledge-base/categories">Categories</Link>
            </Menu.Item>
          )}
          {(accessControls.can(permissions, 'KBPost.create:any') ||
            accessControls.can(permissions, 'KBPost.update:any')) && (
            <Menu.Item key="/manageKB">
              <Link to="/knowledge-base">Manage Posts</Link>
            </Menu.Item>
          )}
          {accessControls.can(permissions, 'KBPost.read:any') && (
            <Menu.Item key="/knowledge-base/view">
              <Link to="/knowledge-base/view">View</Link>
            </Menu.Item>
          )}
          {/* Photo Gallery */}
          {(accessControls.can(permissions, 'KBPost.read:any') ||
            accessControls.can(permissions, 'KBPost.create:any')) && (
            <Menu.SubMenu key="/gallery" title="Photo Gallery">
              {accessControls.can(permissions, 'KBPost.read:any') && (
                <Menu.Item key="/gallery">
                  <Link to="/gallery">View Gallery</Link>
                </Menu.Item>
              )}
              {accessControls.can(permissions, 'KBPost.create:any') && (
                <Menu.Item key="/gallery/create">
                  <Link to="/gallery/create">Add Photos</Link>
                </Menu.Item>
              )}
            </Menu.SubMenu>
          )}
        </Menu.SubMenu>
      )}

      {/* Network Management */}
      {(accessControls.can(
        permissions,
        'NetworkingToolBranchNetwork.read:any',
      ) ||
        accessControls.can(
          permissions,
          'NetworkingToolBranchCustomer.read:any',
        ) ||
        accessControls.can(permissions, 'NetworkingToolWifiUsers.read:any') ||
        accessControls.can(
          permissions,
          'NetworkingToolOfficeRegistry.read:any',
        ) ||
        accessControls.can(
          permissions,
          'NetworkingToolPortRegistry.read:any',
        ) ||
        accessControls.can(
          permissions,
          'NetworkingToolMapIpAddressToClient.read:any',
        ) ||
        accessControls.can(
          permissions,
          'NetworkingToolRackRegistry.read:any',
        )) && (
        <Menu.SubMenu
          key="/network-management"
          icon={<GlobalOutlined style={{ fontSize: '16px' }} />}
          title="Network Management"
        >
          {accessControls.can(
            permissions,
            'NetworkingToolBranchNetwork.read:any',
          ) && (
            <Menu.Item
              key="/branchnetwork"
              icon={<GoldOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/branchnetwork">Branch Network</Link>
            </Menu.Item>
          )}
          {accessControls.can(
            permissions,
            'NetworkingToolBranchCustomer.read:any',
          ) && (
            <Menu.Item
              key="/branchcustomer"
              icon={<BankOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/branchcustomer">Branch Clients</Link>
            </Menu.Item>
          )}
          {accessControls.can(
            permissions,
            'NetworkingToolWifiUsers.read:any',
          ) && (
            <Menu.Item
              key="/wifiusers"
              icon={<WifiOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/wifiusers">Wi-Fi Users</Link>
            </Menu.Item>
          )}
          {accessControls.can(
            permissions,
            'NetworkingToolOfficeRegistry.read:any',
          ) && (
            <Menu.Item
              key="/officeregistry"
              icon={<GoldOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/officeregistry">Office Assignment</Link>
            </Menu.Item>
          )}
          {accessControls.can(
            permissions,
            'NetworkingToolPortRegistry.read:any',
          ) && (
            <Menu.Item
              key="/portregistry"
              icon={<CodeSandboxOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/portregistry">Switch Port Registry</Link>
            </Menu.Item>
          )}
          {accessControls.can(
            permissions,
            'NetworkingToolMapIpAddressToClient.read:any',
          ) && (
            <Menu.Item
              key="/map-ip-address-to-client"
              icon={<GlobalOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/map-ip-address-to-client">
                Public IP List
              </Link>
            </Menu.Item>
          )}
          {accessControls.can(
            permissions,
            'NetworkingToolMapIpAddressToClient.read:any',
          ) && (
            <Menu.Item
              key="/map-port-to-client"
              icon={<LinkOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/map-port-to-client">Public Port List</Link>
            </Menu.Item>
          )}
          {accessControls.can(
            permissions,
            'NetworkingToolRackRegistry.read:any',
          ) && (
            <Menu.Item
              key="/rackregistry"
              icon={<CodeSandboxOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/rackregistry">Rack Diagram</Link>
            </Menu.Item>
          )}
        </Menu.SubMenu>
      )}

      {/* Tech Tools */}
      {
        // accessControls.can(
        //   permissions,
        //   'NetworkingToolDeviceRegistry.read:any',
        // ) ||
        // accessControls.can(permissions, 'RadDbReports.read:any') ||
        (accessControls.can(permissions, 'NetworkingToolWifiUsers.read:any') ||
          accessControls.can(
            permissions,
            'NetworkingToolRackDevice.read:any',
          ) ||
          accessControls.can(
            permissions,
            'NetworkingToolPortRegistry.read:any',
          )) && (
          <Menu.SubMenu
            key="/tech-tools"
            icon={<ToolOutlined style={{ fontSize: '16px' }} />}
            title="Tech Tools"
          >
            {accessControls.can(
              permissions,
              'NetworkingToolDeviceRegistry.read:any',
            ) && (
              <Menu.Item
                key="/deviceregistry"
                icon={<DatabaseOutlined style={{ fontSize: '16px' }} />}
              >
                <Link to="/deviceregistry">Device Registry</Link>
              </Menu.Item>
            )}
            {accessControls.can(permissions, 'RadDbReports.read:any') && (
              <Menu.Item
                key="/raddb-reports"
                icon={<LoginOutlined style={{ fontSize: '16px' }} />}
              >
                <Link to="/raddb-reports">Login Attempts</Link>
              </Menu.Item>
            )}
            {accessControls.can(
              permissions,
              'NetworkingToolWifiUsers.read:any',
            ) && (
              <Menu.Item
                key="/wifiusers/wifiusers-super-admin"
                icon={<WifiOutlined style={{ fontSize: '16px' }} />}
              >
                <Link to="/wifiusers/wifiusers-super-admin">
                  Super Admin Wi-Fi Users
                </Link>
              </Menu.Item>
            )}
            {accessControls.can(
              permissions,
              'NetworkingToolRackDevice.read:any',
            ) && (
              <Menu.Item
                key="/rackdevice"
                icon={<HddOutlined style={{ fontSize: '16px' }} />}
              >
                <Link to="/rackdevice">Rack Devices</Link>
              </Menu.Item>
            )}
            {accessControls.can(
              permissions,
              'NetworkingToolPortRegistry.read:any',
            ) && (
              <Menu.Item
                key="/officenumber"
                icon={<PhoneOutlined style={{ fontSize: '16px' }} />}
              >
                <Link to="/officenumber">Office Management</Link>
              </Menu.Item>
            )}
          </Menu.SubMenu>
        )
      }

      {/* Monitoring & Logs */}
      {(accessControls.can(permissions, 'ViewExpectLogs.read:any') ||
        accessControls.can(permissions, 'NetworkingToolReports.read:any')) && (
        <Menu.SubMenu
          key="/monitoring-logs"
          icon={<DatabaseOutlined style={{ fontSize: '16px' }} />}
          title="Monitoring & Logs"
        >
          {accessControls.can(permissions, 'ViewExpectLogs.read:any') && (
            <Menu.Item
              key="/devicelog"
              icon={<DatabaseOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/devicelog">Device Logs</Link>
            </Menu.Item>
          )}
          {accessControls.can(permissions, 'ViewExpectLogs.read:any') && (
            <Menu.Item
              key="/devicebackup"
              icon={<DatabaseOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/devicebackup">Device Backups</Link>
            </Menu.Item>
          )}
          {accessControls.can(
            permissions,
            'NetworkingToolReports.read:any',
          ) && (
            <Menu.Item
              key="/expect-scripts"
              icon={<ToolOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/expect-scripts">Device Scripts</Link>
            </Menu.Item>
          )}
          {accessControls.can(
            permissions,
            'NetworkingToolReports.read:any',
          ) && (
            <Menu.Item
              key="/dashboardlog"
              icon={<DashboardOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/dashboardlog">Dashboard Log</Link>
            </Menu.Item>
          )}
          {accessControls.can(
            permissions,
            'NetworkingToolReports.read:any',
          ) && (
            <Menu.Item
              key="/expansive-api-data"
              icon={<ApiOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/expansive-api-data">Expansive API Data</Link>
            </Menu.Item>
          )}
          {accessControls.can(permissions, 'SuperAdmin.read:any') && (
            <Menu.Item
              key="/email-send-log"
              icon={<MailOutlined style={{ fontSize: '16px' }} />}
            >
              <Link to="/email-send-log">Email log</Link>
            </Menu.Item>
          )}
        </Menu.SubMenu>
      )}

      {/* ISP Management */}
      {accessControls.can(permissions, 'Isp.read:any') && (
        <Menu.Item
          key="/isp"
          icon={<WifiOutlined style={{ fontSize: '16px' }} />}
        >
          <Link to="/isp">ISP Management</Link>
        </Menu.Item>
      )}

      {/* Utility Providers */}
      {accessControls.can(permissions, 'UtilityProviders.read:any') && (
        <Menu.Item
          key="/utility-providers"
          icon={<ToolOutlined style={{ fontSize: '16px' }} />}
        >
          <Link to="/utility-providers">Utility Providers</Link>
        </Menu.Item>
      )}

      {/* Service Providers */}
      {accessControls.can(permissions, 'UtilityProviders.read:any') && (
        <Menu.Item
          key="/service-providers"
          icon={<ApiOutlined style={{ fontSize: '16px' }} />}
        >
          <Link to="/service-providers">Service Providers</Link>
        </Menu.Item>
      )}

      {/* Billing System */}
      {accessControls.can(permissions, 'BillingSystem.read:any') && (
        <Menu.SubMenu
          key="/billing"
          icon={<BankOutlined style={{ fontSize: '16px' }} />}
          title="Billing"
        >
          <Menu.Item
            key="/billing/dashboard"
            icon={<DashboardOutlined style={{ fontSize: '16px' }} />}
          >
            <Link to="/billing/dashboard">Dashboard</Link>
          </Menu.Item>
          <Menu.Item
            key="/billing/invoices"
            icon={<FileTextOutlined style={{ fontSize: '16px' }} />}
          >
            <Link to="/billing/invoices">Invoices</Link>
          </Menu.Item>
          <Menu.Item
            key="/billing/recurring"
            icon={<SyncOutlined style={{ fontSize: '16px' }} />}
          >
            <Link to="/billing/recurring">Recurring</Link>
          </Menu.Item>
          <Menu.Item
            key="/billing/payments"
            icon={<DollarOutlined style={{ fontSize: '16px' }} />}
          >
            <Link to="/billing/payments">Payments</Link>
          </Menu.Item>
          <Menu.Item
            key="/billing/items"
            icon={<ShoppingOutlined style={{ fontSize: '16px' }} />}
          >
            <Link to="/billing/items">Items (Parts / Services)</Link>
          </Menu.Item>
          <Menu.Item
            key="/billing/categories"
            icon={<TagsOutlined style={{ fontSize: '16px' }} />}
          >
            <Link to="/billing/categories">Categories</Link>
          </Menu.Item>
          <Menu.Item
            key="/billing/tax-rates"
            icon={<PercentageOutlined style={{ fontSize: '16px' }} />}
          >
            <Link to="/billing/tax-rates">Tax Rates</Link>
          </Menu.Item>
          <Menu.Item
            key="/billing/settings"
            icon={<SettingOutlined style={{ fontSize: '16px' }} />}
          >
            <Link to="/billing/settings">Settings</Link>
          </Menu.Item>
        </Menu.SubMenu>
      )}

      {/* Ticket System — Super Admin only */}
      {accessControls.can(permissions, 'TicketSystem.read:any') && (
        <Menu.SubMenu
          key="/tickets"
          icon={<CheckSquareOutlined style={{ fontSize: '16px' }} />}
          title="Tickets"
        >
          <Menu.Item
            key="/tickets/dashboard"
            icon={<DashboardOutlined style={{ fontSize: '16px' }} />}
          >
            <Link to="/tickets/dashboard">Dashboard</Link>
          </Menu.Item>
          <Menu.Item
            key="/tickets/projects"
            icon={<AppstoreOutlined style={{ fontSize: '16px' }} />}
          >
            <Link to="/tickets/projects">Projects</Link>
          </Menu.Item>
          <Menu.Item
            key="/tickets/all"
            icon={<FileTextOutlined style={{ fontSize: '16px' }} />}
          >
            <Link to="/tickets/all">All Tickets</Link>
          </Menu.Item>
        </Menu.SubMenu>
      )}

      {/* Workspace */}
      {accessControls.can(permissions, 'WorkspaceManagement.read:any') && (
        <Menu.Item
          key="/workspace"
          icon={<CodeSandboxOutlined style={{ fontSize: '16px' }} />}
        >
          <Link to="/workspace">Workspace</Link>
        </Menu.Item>
      )}

      {/* Sales Agents */}
      {accessControls.can(permissions, 'SalesPerson.read:any') && (
        <Menu.Item
          key="/sales_person"
          icon={<TeamOutlined style={{ fontSize: '16px' }} />}
        >
          <Link to="/sales_person">Sales Agents</Link>
        </Menu.Item>
      )}

      {/* Website Management */}
      {accessControls.can(permissions, 'Website.read:any') && (
        <Menu.Item
          key="/website"
          icon={<GlobalOutlined style={{ fontSize: '16px' }} />}
        >
          <Link to="/website/page/index">Website Management</Link>
        </Menu.Item>
      )}

      {!networkSettings.hide_logout && (
        <Menu.Item
          key="/logout"
          icon={<LogoutOutlined style={{ fontSize: '16px' }} />}
        >
          <Link to="/logout">Logout</Link>
        </Menu.Item>
      )}
    </Menu>
  );
};

export default DefaultSuperAdminMenu;
